import * as moment from 'moment';
import { isMoment, Moment } from 'moment';
import { isString } from 'lodash-es';

export function momentFilter() {
  return ( date: Moment | Date | string, format: string = 'DD.MM.YYYY' ): string => {
    if ( isMoment(date) ) {
      return date.format(format);
    }
    if ( date instanceof Date ) {
      return moment(date).format(format);
    }
    if ( isString(date) ) {
      const momentDate = moment(date);
      if ( momentDate.isValid() ) {
        return momentDate.format(format);
      }
      return null;
    }
    return null;
  };
}



// WEBPACK FOOTER //
// ./app/shared/filters/moment.filter.ts